import {Link} from "@/shared/ui/Link";
import {Picture} from "@/shared/ui/Picture";
import {getUrl} from "../../model/getUrl";
import {Product} from "../../model/types";
import styles from "./ProductOtherModels.module.scss";

type Props = {
    products: Product[];
};

export const ProductOtherModels = ({products}: Props) => {
    if (!products.length) {
        return null;
    }

    return (
        <div className={styles.container}>
            <p className={styles.title}>Другие варианты модели</p>
            <div className={styles.items}>
                {products.map(product => (
                    <Link key={product.id} href={getUrl(product)} className={styles.item}>
                        <Picture src={product.img} alt={product.h1} />
                    </Link>
                ))}
            </div>
        </div>
    );
};
